module.exports = __webpack_public_path__ + "static/img/A86.941785b9.jpg";